/* SVARTWEAR — Fluid im Hero.
   Video laeuft stumm im Loop und pausiert, sobald der Hero aus dem Bild ist.
   Bei reduzierter Bewegung laeuft nichts, es bleibt das Standbild.
   Keine externe Bibliothek, kein WebGL, nichts ausserhalb des Heros. */
(function () {
  'use strict';

  var roots = document.querySelectorAll('[data-sw-fluid-hero]');
  if (!roots.length) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  Array.prototype.forEach.call(roots, function (root) {
    var videos = Array.prototype.slice.call(root.querySelectorAll('video'));

    /* ── Bewegungsarme Darstellung: Video raus, Standbild bleibt ───────── */
    if (reduced) {
      videos.forEach(function (video) {
        video.pause();
        video.removeAttribute('autoplay');
        video.hidden = true;
      });
      root.setAttribute('data-motion', 'off');
      return;
    }

    /* ── Nur abspielen, solange der Hero sichtbar ist ──────────────────── */
    if (videos.length && 'IntersectionObserver' in window) {
      var watcher = new IntersectionObserver(function (entries) {
        var visible = entries[0].isIntersecting;
        videos.forEach(function (video) {
          // Was CSS ausgeblendet hat, laeuft nie mit. Ohne diese Zeile spielt
          // der Desktop das Mobilvideo unsichtbar im Hintergrund ab.
          if (video.offsetParent === null) {
            if (!video.paused) video.pause();
            return;
          }
          if (visible) {
            var attempt = video.play();
            if (attempt && attempt.catch) attempt.catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.05 });

      watcher.observe(root);
    } else if (videos.length) {
      /* Ohne IntersectionObserver gibt es niemanden, der startet. Seit im
         Abschnitt kein autoplay-Attribut mehr gesetzt wird, muss das sichtbare
         Video hier von Hand anlaufen, sonst bliebe nur das Standbild. */
      videos.forEach(function (video) {
        if (video.offsetParent === null) return;
        var attempt = video.play();
        if (attempt && attempt.catch) attempt.catch(function () {});
      });
    }

    /* ── Leichte Tiefenverschiebung auf Mausbewegung ───────────────────── */
    var layers = Array.prototype.slice.call(root.querySelectorAll('[data-sw-depth]'));
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!layers.length || !fine) return;

    var targetX = 0, targetY = 0, currentX = 0, currentY = 0, running = false;

    var frame = function () {
      currentX += (targetX - currentX) * 0.06;
      currentY += (targetY - currentY) * 0.06;

      layers.forEach(function (layer) {
        var depth = parseFloat(layer.getAttribute('data-sw-depth')) || 0;
        layer.style.transform = 'translate3d(' +
          (currentX * depth).toFixed(2) + 'px,' +
          (currentY * depth).toFixed(2) + 'px,0)';
      });

      if (Math.abs(targetX - currentX) > 0.05 || Math.abs(targetY - currentY) > 0.05) {
        window.requestAnimationFrame(frame);
      } else {
        running = false;
      }
    };

    root.addEventListener('pointermove', function (event) {
      var box = root.getBoundingClientRect();
      targetX = ((event.clientX - box.left) / box.width - 0.5) * 2;
      targetY = ((event.clientY - box.top) / box.height - 0.5) * 2;
      if (!running) {
        running = true;
        window.requestAnimationFrame(frame);
      }
    }, { passive: true });

    root.addEventListener('pointerleave', function () {
      targetX = 0; targetY = 0;
      if (!running) {
        running = true;
        window.requestAnimationFrame(frame);
      }
    }, { passive: true });
  });
})();
